import axios from "axios";
import { API_URL } from "@/config";

const base = `${API_URL}/floorplan`;

// ─── Auth ──────────────────────────────────────────────────────────────────
export const loginFloorPlan = (email: string, password: string) =>
    axios.post(`${base}/auth/login`, { email, password }, { withCredentials: true });

export const logoutFloorPlan = () =>
    axios.post(`${base}/auth/logout`, {}, { withCredentials: true });

export const getCurrentFloorPlan = () =>
    axios.get(`${base}/auth/me`, { withCredentials: true });

// ─── Floor Plan Company ────────────────────────────────────────────────────
export const getFloorPlanStats = () =>
    axios.get(`${base}/stats`, { withCredentials: true }).then((r) => r.data);

export const getLinkedDealers = () =>
    axios.get(`${base}/dealers`, { withCredentials: true }).then((r) => r.data);

export const updateDealerCredit = (dealerId: number, data: {
    credit_limit?: number; available_credit?: number; interest_rate?: string; notes?: string;
}) => axios.patch(`${base}/dealers/${dealerId}/credit`, data, { withCredentials: true }).then((r) => r.data);

export const getDealerInventoryForFloorPlan = (dealerId: number) =>
    axios.get(`${base}/dealers/${dealerId}/inventory`, { withCredentials: true }).then((r) => r.data);

// ─── Dealer ────────────────────────────────────────────────────────────────
export const getDealerFloorPlan = () =>
    axios.get(`${base}/dealer/my-plan`, { withCredentials: true }).then((r) => r.data);

// ─── Admin ─────────────────────────────────────────────────────────────────
export const adminListFloorPlanCompanies = () =>
    axios.get(`${API_URL}/admin/floorplan/companies`, { withCredentials: true }).then((r) => r.data);

export const adminCreateFloorPlanCompany = (data: {
    company_name: string; company_code: string; email: string; password: string;
    phone?: string; contact_name?: string; interest_rate?: string;
    max_credit_line?: string; notes?: string;
}) => axios.post(`${API_URL}/admin/floorplan/companies`, data, { withCredentials: true }).then((r) => r.data);

export const adminUpdateFloorPlanStatus = (id: number, status: string) =>
    axios.patch(`${API_URL}/admin/floorplan/companies/${id}/status`, { status }, { withCredentials: true }).then((r) => r.data);

export const adminLinkDealerToFloorPlan = (companyId: number, dealerId: number, creditLimit: number) =>
    axios.post(`${API_URL}/admin/floorplan/companies/${companyId}/link-dealer`, { dealer_id: dealerId, credit_limit: creditLimit }, { withCredentials: true }).then((r) => r.data);
